import { ReferralToRehabilitationCreateOrUpdateDetails } from '@dreryk/egabinet-referral-frontend-api';

import { Choice } from '@dreryk/watermelon';

import { createReferralDiagnosesPayload } from '../../shared/common.utils';
import { ReferralToRehabilitationFormBean } from '../ReferralToRehabilitationForm/ReferralToRehabilitationForm.types';

export const mapReferralToRehabilitationFormBeanToCommandReferralDetails = (
   formData: ReferralToRehabilitationFormBean
): ReferralToRehabilitationCreateOrUpdateDetails => {
   return {
      cito: formData.cito ?? false,
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      rehabilitationClinicCode: Choice.withUseDefaultIfNull(formData.healthcareFacilityLocationSpecialty?.code ?? null),
      unitNameAndAddress: Choice.withUseDefaultIfNull(formData.unitNameAndAddress ?? null),
      diagnoses: createReferralDiagnosesPayload(formData.diagnoses.value),
      objective: Choice.withUseDefaultIfNull(formData.objective ?? null),
      preexistingDiseases: Choice.withUseDefaultIfNull(formData.illnessesAlreadyPassed ?? null),
      examinationsPerformed: Choice.withUseDefaultIfNull(formData.examinationsAlreadyPerformed ?? null),
      additionalInformation: Choice.withUseDefaultIfNull(formData.additionalInformation ?? null),
      electronic: false,
      icd9ProceduresCodes: formData.icd9Procedures.map(({ code }) => code),
   };
};
